import store from '@/store'

export default class OpenCompanyUrlMiddleware {
    /**
     * Inicializa este middleware
     *
     * @param {string} storePath caminho do módulo do vuex
     * @param {string} attributePath nome do atributo a ser consultado
     */
    constructor(storePath, attributePath) {
        this._storePath = storePath
        this._attributePath = attributePath
    }

    handle(to, from, next) {
        let url = store.getters[this._storePath][this._attributePath]

        if (!url)
            return

        let newTab = window.open(url, '_blank')
        newTab.focus()
        return
    }
}